import * as React from 'react';
import { NavigationContext } from '@src/context/navigation-store/navigation-store';
import { Breadcrumbs, BreadcrumbsItem } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { PageRoute } from '@src/types';

import * as css from './breadcrumbs.scss';

export function BreadcrumbsComponent() {
  const { navigateToRoute, breadcrumbItems } = React.useContext(NavigationContext);
  if (breadcrumbItems.length === 0) {
    return null;
  }

  const onBreadcrumbsClicked = (breadcrumb: BreadcrumbsItem) => navigateToRoute(breadcrumb.id as PageRoute);

  const lastItem = breadcrumbItems[breadcrumbItems.length - 1];

  return (
    <span className={css.addEllipsisToBreadcrumps}>
      <Breadcrumbs
        dataHook={DataHooks.PageBreadcrumbs}
        activeId={lastItem.id}
        items={breadcrumbItems}
        onClick={onBreadcrumbsClicked}
      />
    </span>
  );
}
